// extracted by mini-css-extract-plugin
module.exports = {"container":"tb","bubbleNav":"ub","graphic":"vb","container404":"wb","container500":"xb","contact":"yb"};